import React, { useCallback } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import PropTypes from 'prop-types';

import GroupWrapper from '../Wrappers/GroupWrapper';

const AlignmentGroup = ({ cellFormat, onFormatChange }) => {
  const handleAlignLeft = useCallback(() => {
    onFormatChange('alignLeft');
  }, [onFormatChange]);

  const handleAlignCenter = useCallback(() => {
    onFormatChange('alignCenter');
  }, [onFormatChange]);

  const handleAlignRight = useCallback(() => {
    onFormatChange('alignRight');
  }, [onFormatChange]);

  return (
    <GroupWrapper label="Alignment">
      <Tooltip title="Align Left">
        <IconButton
          size="small"
          onClick={handleAlignLeft}
          color={cellFormat?.textAlign === 'left' ? 'primary' : 'default'}
        >
          <FormatAlignLeftIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Tooltip title="Align Center">
        <IconButton
          size="small"
          onClick={handleAlignCenter}
          color={cellFormat?.textAlign === 'center' ? 'primary' : 'default'}
        >
          <FormatAlignCenterIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Tooltip title="Align Right">
        <IconButton
          size="small"
          onClick={handleAlignRight}
          color={cellFormat?.textAlign === 'right' ? 'primary' : 'default'}
        >
          <FormatAlignRightIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </GroupWrapper>
  );
};

AlignmentGroup.propTypes = {
  cellFormat: PropTypes.shape({
    textAlign: PropTypes.string,
  }).isRequired,
  onFormatChange: PropTypes.func.isRequired,
};

export default AlignmentGroup;
